import { Session } from "inspector";
import { AppState, BrushState } from "../../../TypesAndConstants/types";

export type SavedBrushedObject = {
  name: string;
  brushState: BrushState;
  id: number;
};

export const getSavedBrushes = () => {
  const sessionKey = "brushes";
  const session = sessionStorage.getItem(sessionKey);
  if (session) {
    const brushes = JSON.parse(session) as SavedBrushedObject[];
    return brushes;
  }
  return false;
};

const sessionGetBrush = (key: string) => {
  const sessionKey = "brushes";
  const session = sessionStorage.getItem(sessionKey);
  if (session) {
    const brushes = JSON.parse(session) as SavedBrushedObject[];
    const brush = brushes.find((i) => {
      return i.name === key;
    });
    return brush ?? false;
  }
  return false;
};

export const getSavedBrush = (key: string) => {
  if (process.env.NODE_ENV === "development") {
    sessionGetBrush(key);
  } else {
  }
};

export const saveBrushToSession = (state: AppState, title: string) => {
  const sessionKey = "brushes";
  const brush = extractState(state);
  const session = sessionStorage.getItem(sessionKey);
  if (session) {
    const brushes = JSON.parse(session) as SavedBrushedObject[];
    brushes.push({ name: title, brushState: { isPaletteUsed: false, ...brush}, id: Date.now() });
    sessionStorage.setItem(sessionKey, JSON.stringify(brushes));
    return brushes;
  } else {
    sessionStorage.setItem(
      sessionKey,
      JSON.stringify([{ name: title, brushState: brush }])
    );
  }
  return false;
};

export const saveBrushAPI = (state: AppState) => {
  return extractState(state) as BrushState;
};

export const deleteBrushFromSession = (brush: string) => {
  const sessionKey = "brushes";
  const session = sessionStorage.getItem(sessionKey);
  if (session) {
    const brushes = JSON.parse(session) as SavedBrushedObject[];
    const filteredBrush = brushes.filter((b) => {
      return b.name !== brush;
    });
    sessionStorage.setItem(sessionKey, JSON.stringify(filteredBrush));
    return brushes;
  }
  return false;
};

export const extractState = (state: AppState) => {
  return {
    activeBrush: state.activeBrush,
    animation: state.animation,
    brushType: state.brushType,
    brushColor: state.brushColor,
    cachedColorData: state.cachedColorData,
    globalColorData: state.globalColorData,
    brushIsAnimated: state.brushIsAnimated,
    brushSize: state.brushSize,
    brushCount: state.brushCount,
    brushSpeed: state.brushSpeed,
    colorIsAnimated: state.colorIsAnimated,
    colorTransitionSpeed: state.colorTransitionSpeed,
    growShrink: state.growShrink,
    penPath: state.penPath,
    penRadius: state.penRadius,
    penSpeed: state.penSpeed,
    shapeSettings: state.shapeSettings,
    wipeCount: state.wipeCount,
    wipeSpeed: state.wipeSpeed,
    wipeSpan: state.wipeSpan,
    wipeDirection: state.wipeDirection,
  };
};

export const loadBrushState = (brushState: BrushState, state: AppState) => {
  return {
    ...state,
    activeBrush: brushState.activeBrush,
    animation: brushState.animation,
    brushType: brushState.brushType,
    brushColor: brushState.brushColor,
    cachedColorData: brushState.cachedColorData,
    globalColorDate: brushState.globalColorData,
    brushIsAnimated: brushState.brushIsAnimated,
    brushSize: brushState.brushSize,
    brushCount: brushState.brushCount,
    brushSpeed: brushState.brushSpeed,
    colorIsAnimated: brushState.colorIsAnimated,
    colorTransitionSpeed: brushState.colorTransitionSpeed,
    growShrink: brushState.growShrink,
    penPath: brushState.penPath,
    penRadius: brushState.penRadius,
    penSpeed: brushState.penSpeed,
    shapeSettings: brushState.shapeSettings,
    wipeCount: brushState.wipeCount,
    wipeSpeed: brushState.wipeSpeed,
    wipeSpan: brushState.wipeSpan,
    wipeDirection: brushState.wipeDirection,
  };
};
